import { useColorScheme } from '@mui/joy/styles';
import GlobalStyles from '@mui/joy/GlobalStyles';

/**
 * Componente que aplica estilos globais para manter a sidebar sempre no modo escuro
 * independentemente do tema global da aplicação
 */
export function DarkSidebarStyles() {
  
  return (
    <GlobalStyles
      styles={`
        .dark-sidebar {
          /* Variáveis de cores principais */
          --joy-palette-background-surface: var(--joy-palette-neutral-900);
          --joy-palette-background-level1: var(--joy-palette-common-black);
          --joy-palette-background-body: var(--joy-palette-neutral-900);
          --joy-palette-background-backdrop: var(--joy-palette-common-black);
          --joy-palette-background-popup: var(--joy-palette-neutral-900);
          --joy-palette-neutral-plainColor: var(--joy-palette-neutral-100);
          --joy-palette-neutral-plainHoverBg: var(--joy-palette-neutral-800);
          --joy-palette-neutral-plainActiveBg: var(--joy-palette-neutral-700);
          --joy-palette-neutral-outlinedBorder: var(--joy-palette-neutral-700);
          --joy-palette-neutral-outlinedHoverBg: var(--joy-palette-neutral-800);
          --joy-palette-text-primary: var(--joy-palette-common-white);
          --joy-palette-text-secondary: var(--joy-palette-neutral-300);
          --joy-palette-text-tertiary: var(--joy-palette-neutral-400);
          --joy-palette-divider: var(--joy-palette-neutral-800);
          
          /* Cores para o logo */
          --joy-palette-success-softBg: var(--joy-palette-success-900);
          --joy-palette-success-softHoverBg: var(--joy-palette-success-800);
          
          /* Cores para menus e dropdowns */
          --joy-palette-primary-softBg: var(--joy-palette-success-900);
          --joy-palette-primary-softColor: var(--joy-palette-success-200);
          --joy-palette-neutral-softHoverBg: var(--joy-palette-neutral-800);
          
          /* Cores para os botões de Suporte e Configurações */
          --joy-palette-neutral-plainHoverColor: var(--joy-palette-common-white);
        }
        
        /* Estilos para os botões de itens da lista */
        .dark-sidebar .MuiListItemButton-root:hover {
          background-color: var(--joy-palette-neutral-800);
          color: var(--joy-palette-common-white);
        }
        
        /* Estilos para itens selecionados - Modo Escuro (padrão) */
        [data-joy-color-scheme="dark"] .dark-sidebar .MuiListItemButton-root.Mui-selected {
          background-color: var(--joy-palette-success-900);
          color: var(--joy-palette-success-200);
        }
        
        [data-joy-color-scheme="dark"] .dark-sidebar .MuiListItemButton-root.Mui-selected:hover {
          background-color: var(--joy-palette-success-800);
        }
        
        /* Estilos para itens selecionados - Modo Claro (igual ao modo escuro) */
        [data-joy-color-scheme="light"] .dark-sidebar .MuiListItemButton-root.Mui-selected {
          background-color: var(--joy-palette-success-900);
          color: var(--joy-palette-success-200);
        }
        
        [data-joy-color-scheme="light"] .dark-sidebar .MuiListItemButton-root.Mui-selected:hover {
          background-color: var(--joy-palette-success-800);
        }
        
        /* Estilos padrão para itens selecionados (fallback) */
        .dark-sidebar .MuiListItemButton-root.Mui-selected {
          background-color: var(--joy-palette-success-900);
          color: var(--joy-palette-success-200);
        }
        
        .dark-sidebar .MuiListItemButton-root.Mui-selected:hover {
          background-color: var(--joy-palette-success-800);
        }
        
        /* Estilos para divisores */
        .dark-sidebar .MuiDivider-root {
          border-color: var(--joy-palette-neutral-700);
        }
        
        /* Estilos para ícones */
        .dark-sidebar .MuiSvgIcon-root {
          color: var(--joy-palette-neutral-300) !important;
        }
        
        /* Estilos para ícones dentro de botões */
        .dark-sidebar .MuiListItemButton-root .MuiSvgIcon-root,
        .dark-sidebar .MuiIconButton-root .MuiSvgIcon-root {
          color: var(--joy-palette-neutral-300) !important;
        }
        
        /* Estilos para ícones dentro de botões selecionados - Modo Escuro */
        [data-joy-color-scheme="dark"] .dark-sidebar .MuiListItemButton-root.Mui-selected .MuiSvgIcon-root {
          color: var(--joy-palette-success-300) !important;
        }
        
        /* Estilos para ícones dentro de botões selecionados - Modo Claro */
        [data-joy-color-scheme="light"] .dark-sidebar .MuiListItemButton-root.Mui-selected .MuiSvgIcon-root {
          color: var(--joy-palette-success-300) !important;
        }
        
        /* Fallback para ícones dentro de botões selecionados */
        .dark-sidebar .MuiListItemButton-root.Mui-selected .MuiSvgIcon-root {
          color: var(--joy-palette-success-300) !important;
        }
        
        /* Estilos para ícones durante hover */
        .dark-sidebar .MuiListItemButton-root:hover .MuiSvgIcon-root,
        .dark-sidebar .MuiIconButton-root:hover .MuiSvgIcon-root {
          color: var(--joy-palette-common-white) !important;
        }
        
        /* Estilos para botões de ícone */
        .dark-sidebar .MuiIconButton-root {
          color: var(--joy-palette-neutral-200);
        }
        
        .dark-sidebar .MuiIconButton-root:hover {
          background-color: var(--joy-palette-neutral-800);
        }
        
        /* Estilos para o logo */
        .dark-sidebar .logo-button {
          background-color: transparent !important;
        }
        
        .dark-sidebar .logo-button:hover {
          background-color: transparent !important;
        }
        
        /* Estilos para o campo de pesquisa */
        .dark-sidebar .MuiInput-root {
          --Input-focusedHighlight: var(--joy-palette-success-500);
          --Input-focusedThickness: 2px;
          background-color: var(--joy-palette-neutral-800);
          border-color: var(--joy-palette-neutral-700);
        }
        
        .dark-sidebar .MuiInput-root input {
          color: var(--joy-palette-common-white);
        }
        
        .dark-sidebar .MuiInput-root input::placeholder {
          color: var(--joy-palette-neutral-400);
          opacity: 1;
        }
        
        .dark-sidebar .MuiInput-startDecorator {
          color: var(--joy-palette-neutral-400);
        }
        
        /* Estilos para poppers e dropdown menus - Modo Escuro */
        [data-joy-color-scheme="dark"] .dark-sidebar .MuiPopper-root {
          --joy-palette-background-surface: var(--joy-palette-neutral-900) !important;
          --joy-palette-background-level1: var(--joy-palette-common-black) !important;
          --joy-palette-neutral-softHoverBg: var(--joy-palette-neutral-800) !important;
          --joy-palette-primary-softBg: var(--joy-palette-success-900) !important;
          border-radius: 6px !important;
          overflow: hidden !important;
        }
        
        /* Estilos para poppers e dropdown menus - Modo Claro */
        [data-joy-color-scheme="light"] .dark-sidebar .MuiPopper-root {
          --joy-palette-background-surface: var(--joy-palette-neutral-900) !important;
          --joy-palette-background-level1: var(--joy-palette-common-black) !important;
          --joy-palette-neutral-softHoverBg: var(--joy-palette-neutral-800) !important;
          --joy-palette-primary-softBg: var(--joy-palette-success-900) !important;
          border-radius: 6px !important;
          overflow: hidden !important;
        }
        
        /* Fallback para poppers e dropdown menus */
        .dark-sidebar .MuiPopper-root {
          --joy-palette-background-surface: var(--joy-palette-neutral-900) !important;
          --joy-palette-background-level1: var(--joy-palette-common-black) !important;
          --joy-palette-neutral-softHoverBg: var(--joy-palette-neutral-800) !important;
          --joy-palette-primary-softBg: var(--joy-palette-success-900) !important;
          border-radius: 6px !important;
          overflow: hidden !important;
        }
        
        /* Estilo específico para os poppers criados pela sidebar dark */
        .dark-sidebar-popper {
          --joy-palette-background-surface: var(--joy-palette-neutral-900) !important;
          --joy-palette-background-level1: var(--joy-palette-common-black) !important;
          --joy-palette-neutral-softHoverBg: var(--joy-palette-neutral-800) !important;
          --joy-palette-primary-softBg: var(--joy-palette-success-900) !important;
          --joy-palette-divider: var(--joy-palette-neutral-800) !important;
          --joy-palette-text-primary: var(--joy-palette-common-white) !important;
          --joy-palette-text-secondary: var(--joy-palette-neutral-200) !important;
          background-color: var(--joy-palette-neutral-900) !important;
          border-color: var(--joy-palette-neutral-700) !important;
          color: var(--joy-palette-common-white) !important;
          border-radius: 6px !important;
          overflow: hidden !important;
        }
        
        /* Corrige o problema da borda no white mode */
        [data-joy-color-scheme="light"] .dark-sidebar-popper {
          border-radius: 6px !important;
          overflow: hidden !important;
        }

        /* Corrige a cor de fundo para os poppers no white mode */
        [data-joy-color-scheme="light"] .dark-sidebar-popper::before {
          content: "" !important;
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          background-color: var(--joy-palette-neutral-900) !important;
          border-radius: 6px !important;
          z-index: -1 !important;
        }
        
        /* Sobrescreve os estilos do MuiSheet dentro dos poppers */
        [data-joy-color-scheme="light"] .dark-sidebar-popper .MuiSheet-root,
        .dark-sidebar-popper .MuiSheet-root {
          background-color: var(--joy-palette-neutral-900) !important;
          border-color: var(--joy-palette-neutral-700) !important;
          color: var(--joy-palette-common-white) !important;
          border-radius: 6px !important;
          overflow: hidden !important;
        }
        
        /* Estilos para itens de submenu */
        .dark-sidebar a,
        .dark-sidebar [role="menuitem"],
        .dark-sidebar .submenu-item {
          color: var(--joy-palette-common-white) !important;
          text-decoration: none;
        }
        
        .dark-sidebar a:hover,
        .dark-sidebar [role="menuitem"]:hover,
        .dark-sidebar .submenu-item:hover {
          background-color: var(--joy-palette-neutral-800) !important;
          color: var(--joy-palette-common-white) !important;
        }
        
        /* Estilos para submenu item selecionado (ajustado para modo claro) */
        [data-joy-color-scheme="light"] .dark-sidebar .submenu-item[style*="bgcolor"] {
          background-color: var(--joy-palette-success-900) !important;
        }
        
        /* Estilos para tipografia em geral na sidebar */
        .dark-sidebar .MuiTypography-root {
          color: var(--joy-palette-common-white);
        }
        
        /* Estilos para os botões de Suporte e Configurações */
        .dark-sidebar .footer-button {
          color: var(--joy-palette-common-white) !important;
        }
        
        .dark-sidebar .footer-button:hover {
          background-color: var(--joy-palette-neutral-800) !important;
          color: var(--joy-palette-common-white) !important;
        }
        
        /* Estilos padrão para tooltips */
        .dark-sidebar-tooltip {
          --Tooltip-background: var(--joy-palette-neutral-900) !important;
          --Tooltip-color: var(--joy-palette-common-white) !important;
          --joy-shadowRing: none !important;
          border-radius: 6px !important;
          overflow: hidden !important;
        }

        /* Estilos de tooltip para o modo claro - iguais aos poppers */
        [data-joy-color-scheme="light"] .dark-sidebar-tooltip {
          --Tooltip-background: var(--joy-palette-neutral-900) !important;
          --Tooltip-color: var(--joy-palette-common-white) !important;
          --joy-shadowRing: none !important;
          border-radius: 6px !important;
          overflow: hidden !important;
        }

        /* Adiciona um pseudo-elemento para garantir a borda consistente no modo claro */
        [data-joy-color-scheme="light"] .MuiTooltip-popper[data-joy-placement] .dark-sidebar-tooltip::before {
          content: "" !important;
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          background-color: var(--joy-palette-neutral-900) !important;
          border-radius: 6px !important;
          z-index: -1 !important;
        }

        /* Estilos globais para tooltips no tema claro */
        [data-joy-color-scheme="light"] .MuiTooltip-tooltip {
          background-color: #121212 !important;
          color: #ffffff !important;
          box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15) !important;
          border: 1px solid rgba(104, 112, 118, 0.2) !important;
        }

        /* Estilo global para todos os tooltips da sidebar */
        .dark-sidebar .MuiTooltip-popper .MuiTooltip-tooltip {
          background-color: #121212 !important;
          color: #ffffff !important;
          border: 1px solid rgba(104, 112, 118, 0.2) !important;
          box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15) !important;
          border-radius: 6px !important;
          overflow: hidden !important;
        }

        /* Estilo diretamente no elemento tooltip */
        [data-joy-color-scheme="light"] .MuiTooltip-popper[data-joy-placement] {
          --Tooltip-background: #121212 !important;
          --Tooltip-color: #ffffff !important;
          --joy-shadowRing: none !important;
        }
      `}
    />
  );
} 